import { Component, ElementRef, Input, OnInit, Renderer2, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Icon, IconType } from '../../../common/model/icon';

const ICON_COMPONENT_NAME = 'app-icon';

@Component({
  selector: ICON_COMPONENT_NAME,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {

  @Input()
  icon: Icon;

  iconType = IconType;

  @ViewChild(TemplateRef, { read: TemplateRef, static: true })
  public template: TemplateRef<void>;

  constructor(private readonly renderer2: Renderer2, private readonly elementRef: ElementRef<HTMLElement>,
              private readonly viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    const comment = this.renderer2.createComment(ICON_COMPONENT_NAME);
    const parentNode = this.renderer2.parentNode(this.elementRef.nativeElement);
    this.viewContainerRef.createEmbeddedView(this.template);
    this.renderer2.insertBefore(parentNode, comment, this.elementRef.nativeElement);
    this.renderer2.removeChild(parentNode, this.elementRef.nativeElement);
  }

}
